import React from 'react'
import './style.sass'

const PageNotFound = () => {
  return (
    <div className="page-not-found-container">
      Page Not Found
    </div>
  )
}

export default PageNotFound